

export const JsonFormMode = {
  READ_ONLY: 'read-only',
};

export type JsonFormMode = (typeof JsonFormMode)[keyof typeof JsonFormMode];

export const CustomerType = {
  admin: 'ADMIN',
  lender: 'LENDER',
  vendor: 'VENDOR',
};

export const CustomerPermissionsRole = {
  SuperAdmin: 'SuperAdmin',
  Ops: 'Ops',
  Manager: 'Manager',
  LoanOfficer: 'LoanOfficer',
  Broker: 'Broker',
  AllocationAdmin: 'AllocationAdmin',
  BulkOrderUploader: 'BulkOrderUploader',
  AllocationEditor: 'AllocationEditor'
};
export type CustomerType = (typeof CustomerType)[keyof typeof CustomerType];
export type CustomerPermissionsRole = (typeof CustomerPermissionsRole)[keyof typeof CustomerPermissionsRole];
